import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IProductVariant } from 'src/models/Products/ProductVariant.models'

interface ProductVariantState {
  productVariants: IProductVariant[]
  productVariantToEdit: IProductVariant | null
}

const initialState: ProductVariantState = {
  productVariants: [],
  productVariantToEdit: null
}

const productVariantSlice = createSlice({
  name: 'productVariant',
  initialState,
  reducers: {
    setProductVariantList: (state, productVariant: PayloadAction<IProductVariant[]>) => {
      state.productVariants = productVariant.payload
    },
    concatListProductVariant: (state: ProductVariantState, productVariant: PayloadAction<IProductVariant[]>) => {
      state.productVariants = [...state.productVariants.concat(productVariant.payload)]
    },
    setProductVariantToEdit: (state, ProductVariant: PayloadAction<IProductVariant | null>) => {
      state.productVariantToEdit = ProductVariant.payload
    },
    addProductVariant: (state, productVariant: PayloadAction<IProductVariant>) => {
      state.productVariants.push(productVariant.payload)
    },
    updateProductVariant: (state, productVariant: PayloadAction<IProductVariant>) => {
      const itemIndex = state.productVariants.findIndex(item => item.code === productVariant.payload.code)
      if (itemIndex !== -1) state.productVariants[itemIndex] = productVariant.payload
    },
    deleteProductVariant: (state, productVariant: PayloadAction<number>) => {
      const newArray = state.productVariants.filter(item => item.id !== productVariant.payload)
      state.productVariants = newArray
    }
  }
})

export const {
  setProductVariantList,
  concatListProductVariant,
  setProductVariantToEdit,
  addProductVariant,
  updateProductVariant,
  deleteProductVariant
} = productVariantSlice.actions

export default productVariantSlice.reducer
